import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useApi } from '@/composables/useApi';

export const useKioskStore = defineStore('kiosk', () => {
	const { request } = useApi();

	const kioskId = ref(null);
	const accountId = ref(null);
	const branchId = ref(null);
	const timeout = ref(60);

	async function fetchKiosk(uid){
		kioskId.value = uid;

		const data = await request(`/api/${uid}/kiosk`);

		accountId.value = data?.aid;
		branchId.value = data?.bid;
		timeout.value = data?.appTimerTime || 60;
	}

	return {
		kioskId,
		accountId,
		branchId,
		timeout,
		fetchKiosk
	};
});

